import React from 'react'
import useCareerExploration, {
  CareerExplorationProvider,
} from './CareerExplorationProvider'
import useTranslation, {
  TranslationProvider,
} from '../shared/TranslationProvider'
import * as translations from './locales.json'
import { cn } from '~/lib/utils'
import Results, { PageHeading } from './Results'
import TableOfContents from './TableOfContents'
import YnsIcon from '../icons/YnsIcon'

const CareerExploration = ({ locale, ...props }) => {
  return (
    <TranslationProvider
      translations={translations}
      locale={locale}
      scope="javascript.components.CareerExploration"
    >
      <CareerExplorationProvider {...props}>
        <CareerExplorationInner />
      </CareerExplorationProvider>
    </TranslationProvider>
  )
}
export default CareerExploration

const CareerExplorationInner = () => {
  const { compare } = useCareerExploration()
  const { t } = useTranslation('Page')

  return (
    <div
      className={cn(
        'xl:h-[calc(100vh-80px) flex flex-col font-roboto text-cod-gray-800 xl:grid',
        compare ? 'xl:grid-cols-[1fr]' : 'xl:grid-cols-[1fr_350px]',
      )}
    >
      <div
        className={`home-container flex min-h-0 flex-col overflow-y-auto p-4 md:p-9`}
      >
        <div className="tw-enable font-[Roboto] lg:flex lg:flex-row">
          <div className="flex-grow">
            <div className="flex items-center justify-between">
              <PageHeading />
              <a className="flex items-center" href="/career_exploration">
                {t('back')}
                <span>
                  <YnsIcon name="back" className="ml-2 size-5" />
                </span>
              </a>
            </div>
            <Results />
          </div>
        </div>
      </div>
      {!compare && <TableOfContents />}
    </div>
  )
}
